<ng-container *ngIf="showNewItemSpotlight">
  <bit-spotlight
    [title]="nudgeTitle"
    [subtitle]="nudgeBody"
    (onDismiss)="dismissNewItemSpotlight()"
  >
  </bit-spotlight>
</ng-container>
